<div
  class="container-loader d-flex flex-column justify-content-center align-items-center position-fixed lr-0 tb-0"
  *ngIf="visible$ | async"
>
  <i class="icon icon-kiter text-white"></i>
  <div class="text-white">{{ word$ | async }}{{ points$ | async }}</div>
</div>
